package org.example.zone360.models

data class CoachTalkRatioData(
    val value: Int,
    val clubAverage: Int,
    val target: String,
        val aligned: Boolean,
    val coaches: List<CoachTalkEntry> = emptyList()
)

data class CoachTalkEntry(
    val name: String,
    val talkPercent: Int,
    val target: String,
    val gap: Int
)